export default {
  path: '/analytics/fin_profile',
  name: 'FIN Profile',
  redirect: '/analytics/fin_profile/select_institution',
  meta: { requiredAuth: true },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'select_institution',
      name: 'ProfileInstitution',
      component: () => import('./pages/Institution'),
      meta: {
        type: 'profile',
        modulePath: '/analytics/fin_profile/select_institution'
      }
    },
    {
      path: 'custom_profile',
      name: 'CustomProfile',
      component: () => import('./pages/Profile'),
      meta: {
        type: 'profile',
        modulePath: '/analytics/fin_profile/select_institution'
      }
    }
  ]
}
